import { encryptRelayRequest, RelayCryptoError } from "./crypto.js";
import { connectError, serverConnectError } from "./errors.js";
export async function freshEncryptedRequest(keyStore, token, operation, input, deadlineUnixMs) {
    if (!token.encryption || !token.grantId || !token.keyHandle) {
        throw connectError("authorization_binding_incompatible", "The refreshed authorization no longer supports encrypted connector operations.", {
            details: {
                contract: "grant_encryption",
                required: [1],
                supported: token.encryption ? [token.encryption.protocol_version] : [],
                peer: "connector",
                operation
            }
        });
    }
    try {
        return await encryptRelayRequest(keyStore, token.keyHandle, {
            grantId: token.grantId,
            applicationId: token.clientId,
            encryption: token.encryption
        }, operation, input, undefined, deadlineUnixMs);
    }
    catch (error) {
        if (error instanceof RelayCryptoError) {
            throw serverConnectError(error.code, error.message);
        }
        throw error;
    }
}
